export const LOCAL_STORAGE_SESSION_TOKEN = "scv::gatekeepr";
export const LOCAL_STORAGE_SESSION_TOKEN_EXPIRY = "scv::keeprexpiry";
export const LOCAL_STORAGE_SELF_HANDLE = "scv::self";
export const LOCAL_STORAGE_IMPORT_BANNER = "scv::import_banner";
export const LOCAL_STORAGE_INTEGRATION_BANNER = "scv::integration_banner";
export const SESSION_STORE_SHARE_PIN_UF = (handle) => `privateShare::${handle}`;
